var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGoback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "82E04C08-FB5C-4CA3-93BC-C5880FB895B9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "M\\u0101c\\u012Bbu-grupas---Atv\\u0113rums",
    transform: "translate(-299.000000, -109.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-content",
    transform: "translate(260.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "About",
    transform: "translate(30.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "viewbox",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70710678,4.29289322 C8.09763107,4.68341751 8.09763107,5.31658249 7.70710678,5.70710678 L4.415,9 L18,9 C18.5522847,9 19,9.44771525 19,10 C19,10.5522847 18.5522847,11 18,11 L4.415,11 L7.70710678,14.2928932 C8.06759074,14.6533772 8.09532028,15.2206082 7.79029539,15.6128994 L7.70710678,15.7071068 C7.31658249,16.0976311 6.68341751,16.0976311 6.29289322,15.7071068 L1.29289322,10.7071068 C1.25749917,10.6717127 1.22531295,10.6343256 1.19633458,10.5953066 L1.12467117,10.4840621 L1.07122549,10.371336 L1.03584514,10.265993 L1.0110178,10.1484669 L1.00397748,10.0898018 L1,10 L1.00278786,9.92476146 L1.02024007,9.79927424 L1.04973809,9.68785748 L1.09367336,9.57677845 L1.14599545,9.47929125 L1.21292769,9.38297765 L1.29289322,9.29289322 L6.29289322,4.29289322 C6.68341751,3.90236893 7.31658249,3.90236893 7.70710678,4.29289322 Z",
    id: "icon",
    fill: "#667380",
    fillRule: "nonzero"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoback);
export default __webpack_public_path__ + "static/media/ic-goback.2ebb8a3d3031c247f74fb353a028aba0.svg";
export { ForwardRef as ReactComponent };